import { makeHoneyPotFix } from '../honey-pot-fix/make-honey-pot-fix';

export const honeyPotFix: ReturnType<typeof makeHoneyPotFix> = makeHoneyPotFix();
